import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'

import { listCompaniesOptions } from '@/api/codegen/@tanstack/react-query.gen'

export const Route = createFileRoute('/_auth/$companyId')({
  beforeLoad: async ({ params, context: { queryClient } }) => {
    const companies = await queryClient.ensureQueryData(
      listCompaniesOptions({}),
    )
    const isValidCompany = companies.items?.some(
      (company) => company.id === params.companyId,
    )

    if (!isValidCompany) {
      throw redirect({
        to: '/dashboard',
        replace: true,
      })
    }
  },
  component: () => <Outlet />,
})
